function PricingGrid({ columns = [] }) {
  return (
    <div className={`grid grid-cols-${columns.length} gap-4`}>
      {columns.map((col, i) => (
        <div key={i}>
          <p className="text-[11px] font-medium text-gray-400 uppercase tracking-wider mb-1">
            {col.label}
          </p>
          {col.type === "total" ? (
            <div className="flex items-center gap-2">
              {col.originalValue && (
                <span className="text-xs text-gray-400 line-through">
                  {col.originalValue}
                </span>
              )}
              <span
                className={`text-sm font-semibold ${
                  col.originalValue ? "text-[#27815C]" : "text-gray-900"
                }`}
              >
                {col.value}
              </span>
            </div>
          ) : (
            <p className="text-sm font-semibold text-gray-900">{col.value}</p>
          )}
        </div>
      ))}
    </div>
  );
}

export default PricingGrid;